import Vue from "vue";
import Router from "vue-router";
// import m08f from "@/view/guides/m08f.vue";
import m08f from "@/view/guides/m08f_2.vue";
// import p831 from "@/view/guides/p831.vue";
import p831 from "@/view/guides/newP831.vue";
import m220 from "@/view/guides/m220.vue";
import m221 from "@/view/guides/m221.vue";
import m150 from "@/view/guides/m150.vue";
import m100 from "@/view/guides/m100.vue";
import s821 from "@/view/guides/s821.vue";
import m832 from "@/view/guides/m832.vue";
import m833 from "@/view/guides/m833.vue";
import newM833 from "@/view/guides/newM833.vue";
import m834 from "@/view/guides/m834.vue";
import m835 from "@/view/guides/m835.vue";
import t310 from "@/view/guides/t310.vue";
import t310_itari from "@/view/guides/t310_itari.vue";
import tattoo from "@/view/guides/tattoo.vue";
import Q302 from "@/view/guides/Q302.vue";
import R831 from "@/view/guides/R831.vue";
import TP81 from "@/view/guides/TP81.vue";
import TP82 from "@/view/guides/TP82.vue";
import TP83 from "@/view/guides/TP83.vue";
import TP86 from "@/view/guides/TP86.vue";
import TP87 from "@/view/guides/TP87.vue";
import TP88 from "@/view/guides/TP88.vue";
import G831 from "@/view/guides/G831.vue";
import A30 from "@/view/guides/A30.vue";

import H831 from "@/view/guides/H831.vue";
import H832 from "@/view/guides/H832.vue";
import H833 from "@/view/guides/H833.vue";
import M832_new from "@/view/guides/M832_new.vue";
import G100 from "@/view/newPages/G100.vue";
import M08E from "@/view/newPages/M08E.vue";
import M836 from "@/view/newPages/M836.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/t310_itari",//路径为/时的默认页面路由
    },
    {
      path: "/m08f",
      name: "M08F",
      meta: {
        title: "M08F"
      },
      component: m08f
    }, {
      path: "/p831",
      name: "P831",
      meta: {
        title: "P831"
      },
      component: p831
    }, {
      path: "/m220",
      name: "M220",
      meta: {
        title: "M220"
      },
      component: m220
    }, {
      path: "/m221",
      name: "M221",
      meta: {
        title: "M221"
      },
      component: m221
    }, {
      path: "/m150",
      name: "M150",
      meta: {
        title: "M150"
      },
      component: m150
    }, {
      path: "/m100",
      name: "M100",
      meta: {
        title: "M100"
      },
      component: m100
    },
    {
      path: "/s821",
      name: "S821",
      meta: {
        title: "S821"
      },
      component: s821
    },
    // {
    //   path: "/m832",
    //   name: "M832",
    //   meta: {
    //     title: "M832"
    //   },
    //   component: m832
    // }, 
    {
      path: "/m833",
      name: "M833",
      meta: {
        title: "M833"
      },
      component: newM833
    },
    // {
    //   path: "/newM833",
    //   name: "newM833",
    //   meta: {
    //     title: "newM833"
    //   },
    //   component: newM833
    // },
    {
      path: "/m834",
      name: "M834",
      meta: {
        title: "M834"
      },
      component: m834
    }, {
      path: "/m835",
      name: "M835",
      meta: {
        title: "M835"
      },
      component: m835
    }, {
      path: "/g831",
      name: "G831",
      meta: {
        title: "G831"
      },
      component: G831
    }, {
      path: "/t310",
      name: "T310",
      meta: {
        title: "T310"
      },
      component: t310
    }, {
      path: "/t310_itari",
      name: "T310-Itari",
      meta: {
        title: "T310-Itari"
      },
      component: t310_itari
    }, {
      path: "/tattoo",
      name: "tattoo",
      meta: {
        title: "tattoo"
      },
      component: tattoo
    }, {
      path: "/Q302",
      name: "Q302",
      meta: {
        title: "Q302"
      },
      component: Q302
    }, {
      path: "/R831",
      name: "R831",
      meta: {
        title: "R831"
      },
      component: R831
    }, {
      path: "/TP81",
      name: "TP81",
      meta: {
        title: "TP81"
      },
      component: TP81
    }, {
      path: "/tp82",
      name: "TP82",
      meta: {
        title: "TP82"
      },
      component: TP82
    }, {
      path: "/tp83",
      name: "TP83",
      meta: {
        title: "TP83"
      },
      component: TP83
    },
    {
      path: "/tp86",
      name: "TP86",
      meta: {
        title: "TP86"
      },
      component: TP86
    },
    {
      path: "/tp87",
      name: "TP87",
      meta: {
        title: "TP87"
      },
      component: TP87
    }, {
      path: "/tp88",
      name: "TP88",
      meta: {
        title: "TP88"
      },
      component: TP88
    },
    {
      path: "/A30",
      name: "A30",
      meta: {
        title: "A30"
      },
      component: A30
    }, {
      path: "/h831",
      name: "H831",
      meta: {
        title: "H831"
      },
      component: H831
    }, {
      path: "/h832",
      name: "H832",
      meta: {
        title: "H832"
      },
      component: H832
    }, {
      path: "/h833",
      name: "H833",
      meta: {
        title: "H833"
      },
      component: H833
    }, {
      path: "/m832",
      name: "M832",
      meta: {
        title: "M832"
      },
      component: M832_new
    },
    {
      path: "/m832_old",
      name: "M832_old",
      meta: {
        title: "M832"
      },
      component: m832
    }, {
      path: "/g100",
      name: "G100",
      meta: {
        title: "G100"
      },
      component: G100
    }, {
      path: "/m08e",
      name: "M08E",
      meta: {
        title: "M08E"
      },
      component: M08E
    }, {
      path: "/m836",
      name: "M836",
      meta: {
        title: "M836"
      },
      component: M836
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js